"use client";

import { c as _c } from "react-compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { trackPage } from "@/core/analytics/telemetry/telemetry";

/**
 * The page view, published for EVERY route.
 *
 * Rendered by `InstrumentationProvider`, so it sits beside the app tree in the
 * root layout rather than inside it — which is the whole point. The other
 * publisher, `AnalyticsProvider`, is mounted only by
 * `components/layout/Layout`, so the route groups that ship no provider tree
 * emitted no page view at all: `[lang]/(prelaunch)`, which serves the home
 * page, deliberately omits those providers for mobile LCP, and the home page
 * is the site's highest-traffic route. The engine already reaches it from this
 * position (see `instrumentation.runtime`); now the page view does too.
 *
 * Consent-blind, like every other publisher (`telemetry`): nothing here reads
 * the visitor's decision. InstrumentationProvider configures the bus to hold
 * analytics.page until an answer, deliver it on an analytics grant, and drop
 * it on decline. The bus owns that delivery boundary.
 *
 * Mounted only once the engine is live, which is why there is no "is there an
 * engine" test in here: the parent owns that fact and withholds this component
 * until it holds. That also makes the mount itself the first route's trigger.
 */
export function PageViewReporter() {
  const $ = _c(3);
  const pathname = usePathname();
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      trackPage(pathname);
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}